/* tslint:disable */
/* eslint-disable */
/**
 * Billaan API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Quote } from './Quote';
import {
    QuoteFromJSON,
    QuoteFromJSONTyped,
    QuoteToJSON,
    QuoteToJSONTyped,
} from './Quote';
import type { ApplicationStatus } from './ApplicationStatus';
import {
    ApplicationStatusFromJSON,
    ApplicationStatusFromJSONTyped,
    ApplicationStatusToJSON,
    ApplicationStatusToJSONTyped,
} from './ApplicationStatus';

/**
 * 
 * @export
 * @interface GetApplicationStatusAndQuoteResponse
 */
export interface GetApplicationStatusAndQuoteResponse {
    /**
     * 
     * @type {string}
     * @memberof GetApplicationStatusAndQuoteResponse
     */
    applicationId?: string;
    /**
     * 
     * @type {ApplicationStatus}
     * @memberof GetApplicationStatusAndQuoteResponse
     */
    status?: ApplicationStatus;
    /**
     * 
     * @type {Quote}
     * @memberof GetApplicationStatusAndQuoteResponse
     */
    quote?: Quote;
}



/**
 * Check if a given object implements the GetApplicationStatusAndQuoteResponse interface.
 */
export function instanceOfGetApplicationStatusAndQuoteResponse(value: object): value is GetApplicationStatusAndQuoteResponse {
    return true;
}

export function GetApplicationStatusAndQuoteResponseFromJSON(json: any): GetApplicationStatusAndQuoteResponse {
    return GetApplicationStatusAndQuoteResponseFromJSONTyped(json, false);
}

export function GetApplicationStatusAndQuoteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetApplicationStatusAndQuoteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationId': json['applicationId'] == null ? undefined : json['applicationId'],
        'status': json['status'] == null ? undefined : ApplicationStatusFromJSON(json['status']),
        'quote': json['quote'] == null ? undefined : QuoteFromJSON(json['quote']),
    };
}

export function GetApplicationStatusAndQuoteResponseToJSON(json: any): GetApplicationStatusAndQuoteResponse {
    return GetApplicationStatusAndQuoteResponseToJSONTyped(json, false);
}

export function GetApplicationStatusAndQuoteResponseToJSONTyped(value?: GetApplicationStatusAndQuoteResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationId': value['applicationId'],
        'status': ApplicationStatusToJSON(value['status']),
        'quote': QuoteToJSON(value['quote']),
    };
}

